import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ReservationService } from 'app/pages/trip-reservations/reservations.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { Subscription } from 'rxjs/Subscription';
import { IGeneralData } from '../../../core/interfaces/billing.interface';
import { IDataOfKey } from '../../../core/interfaces/payrolls-detail.interface';
import { assignNewArray } from '../export-functions/functions-services';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { DataProcessingService } from 'app/pages/data-processing/data-processing.service';
import { BillingStatusEnum } from '../../../core/enums/billing-status.enum';
import { constant } from '../../../app.constants';

@Component({
  selector: 'app-change-billing-status',
  templateUrl: './change-billing-status.component.html',
  styleUrls: ['./change-billing-status.component.scss']
})
export class ChangeBillingStatusComponent implements OnInit, OnChanges, OnDestroy {

  @Input() billingStatus: number;
  @Input() trips: any[];
  @Input() viewModal = false;
  @Input() permisons: IDataOfKey<boolean> = undefined;
  @Output() statusChanged = new EventEmitter<any>();
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('noteModal') noteModal: T2CardComponent;
  showedButtons = [];
  note;
  public selectedStatus;
  public selectedBillingStatus: number = undefined;
  public tripsWithErrors = [];
  public status: IGeneralData[] = [];
  public billingStatusList = constant.BILLING_STATUS_LIST;
  private observables: Subscription[] = [];
  constructor(
    private service: ReservationService,
    private loading: T2LoadingService,
    private sweetAlertHelper: SweetAlertHelper,
    private dataProcessingService: DataProcessingService
  ) { }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if ( changes['billingStatus']) {
      this.prepareShowButtons();
    }
  }

  private prepareShowButtons() {
    switch (this.billingStatus) {
      case BillingStatusEnum.Unverified:
        this.showedButtons = [ 'Rejected', 'Pending', 'Verified' ];
        if (this.viewModal) {
          this.generateStatus(assignNewArray(this.showedButtons));
        }
        break;
      case BillingStatusEnum.Verified:
        this.showedButtons = ['Unverified', 'Rejected', 'Pending', 'Billed'];
        if (this.viewModal) {
          this.generateStatus(assignNewArray(this.showedButtons));
        }
        break;
      case BillingStatusEnum.Billed:
        this.showedButtons = ['Unverified', 'Rejected', 'Pending', 'Verified', 'Closed'];
        if (this.viewModal) {
          this.generateStatus(assignNewArray(this.showedButtons));
        }
        break;
      case BillingStatusEnum.Rejected:
        this.showedButtons = ['Unverified', 'Pending', 'Verified', 'Closed'];
        if (this.viewModal) {
          this.generateStatus(assignNewArray(this.showedButtons));
        }
        break;
      case BillingStatusEnum.Pending:
        this.showedButtons = ['Unverified', 'Rejected', 'Verified', 'Closed'];
        if (this.viewModal) {
          this.generateStatus(assignNewArray(this.showedButtons));
        }
        break;
      case BillingStatusEnum.Denied:
        this.showedButtons = ['Unverified', 'Verified', 'Pending', 'Rejected'];
        if (this.viewModal) {
          this.generateStatus(assignNewArray(this.showedButtons));
        }
        break;
      case BillingStatusEnum.Refund:
        this.showedButtons = ['Unverified', 'Verified', 'Pending', 'Rejected'];
        if (this.viewModal) {
          this.generateStatus(assignNewArray(this.showedButtons));
        }
        break;
      case BillingStatusEnum.Closed:
        this.showedButtons = ['Unverified', 'Verified'];
        if (this.viewModal) {
          this.generateStatus(assignNewArray(this.showedButtons));
        }
        break;
      default:
        this.showedButtons = [];
        break;
    }
  }
  /**
   * open note modal
   */
  private openNoteModal() {
    this.noteModal.open();
  }

  /**
   * this force change status
   */
  forceChangeStatus(status) {
    if (!this.note) {
      this.selectedStatus = status;
      this.openNoteModal();
      return;
    }
    if (this.isBillingStatusRejectedSelectedOrError) {
      const data = {
        tripstochange: this.selectedBillingStatus === BillingStatusEnum.Rejected ? this.trips : this.tripsWithErrors,
        billingstatusid: status,
        note: this.note
      }
      this.callService(data);
    }
  }

  /**
   * change status with a note
   */
  changeStatusWithNote() {
    if (this.selectedStatus) {
      const data = {
        tripstochange: this.trips,
        billingstatusid: this.selectedStatus,
        note: this.note
      };
      this.callService(data);
    }
  }

  /**
   * this change status
   * @param statusID status to change
   */
  changeStatus(statusID) {
    if (statusID < this.billingStatus && !this.viewModal) {
      this.selectedStatus = statusID;
      this.openNoteModal();
      return;
    }
    const data = {
      tripstochange: this.trips,
      billingstatusid: statusID,
      note: ''
    }
    this.callService(data);
  }
  /**
   * call service to change status
   * @param data data to send to service
   */
  private callService(data) {
    if (data) {
      this.loading.show();
      this.observables.push(this.service.changeBillingStatus(data)
        .finally(() => {
          this.loading.hiden();
        })
        .subscribe((response: any) => {
          this.updateGridUnverified(response);
          this.buildViewErrors(response, data);
        }, error => this.sweetAlertHelper.captureException(error))
      );
    }
  }

  updateGridUnverified(response) {
    response.map((item) => {
      if (item.success) {
        this.dataProcessingService.getReloadGrid(true);
      }
    });
  }

  /**
   * this emit a custom event
   * @param data
   * @param response
   */
  emitEvent(data, response) {
    const errors = [];
    const success = [];
    response.forEach(el => {
      el.success ? success.push(el.tripid) : errors.push(el.tripid);
    });

    this.statusChanged.emit({errors, success, status: data.billingstatusid});
  }

  /**
   * this build a view to show all errors
   * @param trips change status service response
   */
  private buildViewErrors(trips: any, data?: any) {
    const tripsErrors = [];
    const tripsSuccessful = [];
    trips.forEach(element => {
      if (element.filedarray.length) {
        tripsErrors.push(element);
      } else {
        tripsSuccessful.push(element);
      }
    });
    this.tripsWithErrors = tripsErrors.map((el) => {
      return el.tripid;
    });
    let messages = '';
    tripsErrors.forEach(element => {
      messages +=
      `<div>
        <p><strong>
          Reservation: ${element.consecutive}
        </p></strong>`;
      element.filedarray.forEach(elem => {
        messages += `
          <p>
            ${elem.description}
          </p>
        `;
      });
      messages += `</div>`;
    });

      this.sweetAlertHelper.createCustomAlert({
        title: '<strong>Trips Errors</strong>',
        html: `
          <div class="color-success">Successful Trips: <strong>${tripsSuccessful.length}</strong><div>
          <div class="color-danger">
            Error Trips: <strong>${tripsErrors.length}</strong>
          <div>
          <div class="margin-t-10"><strong>Details of Fails</strong><div>
          <div class="container margin-t-10 height-200 scrollbar scrollbar-small padding-b-100">
            ${messages}
          </div>
        `,
        type: 'info',
        showCancelButton: false,
        confirmButtonText: 'Accept',
        cancelButtonText: 'Cancel'
      }).then(() => {
        if (!tripsErrors.length && this.viewModal) {
          this.statusChanged.emit(true);
          this.onCloseEdit();
          this.emitEvent(data, trips);
        }
      });
    }

    /**
     * this execute when modal emit a event
     */
    onNoteModalEvents(event) {
      if (!event.isOpen) {
        this.note = '';
        this.selectedStatus = undefined;
      }
    }

    /**
     * this return the status name by billingstatusid
     */
  getStatusName() {
    switch (this.billingStatus) {
      case 1:
        return 'Unverified';
      case 2:
        return 'Verified';
      case 3:
        return 'Billed';
      case 4:
        return 'Rejected';
      case 5:
        return 'Denied';
      case 6:
        return 'Closed';
      case 7:
        return 'Processing';
      case 8:
        return 'Pending';
    }
  }
    /**
     * @description genera array de Billing Status
     */
    generateStatus(data: string[]): void {
      this.status = [];
      data.forEach((item: string) => {
        this.status.push({description: item, id: this.billingStatusList[item]});
      });
    }
  /**
   * @description
   */
    public onCloseEdit(): void {
      this.closeModal.emit(true);
    }
  /**
   * @description
   */
    public onSave(): void {
      if (this.isBillingStatusRejectedSelectedOrError) {
        this.forceChangeStatus(this.selectedBillingStatus);
      } else {
        this.changeStatus(this.selectedBillingStatus);
      }
    }
  /**
   * @description para desabilitar boton si viewModal
   */
    public disabledButtonModal(): boolean {
      let value = true;
      if (this.isBillingStatusRejectedSelectedOrError && this.selectedBillingStatus && this.note) {value = false; }
      if (!this.isBillingStatusRejectedSelectedOrError && this.selectedBillingStatus) {value = false; }
      return value;
    }

  get isBillingStatusRejectedSelectedOrError() {
    return (
      this.selectedBillingStatus === BillingStatusEnum.Rejected ||
      (this.tripsWithErrors && this.tripsWithErrors.length)
    );
  }

  ngOnDestroy(): void {
   this.observables.forEach(
     (sub: Subscription) => {sub.unsubscribe(); }
   );
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/change-billing-status/change-billing-status.component.ts